import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { Component, PLATFORM_ID, Inject } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PdvService } from '../../services/pdv/pdv.service';
import { ProductService } from '../../services/product/product.service';
import { OrdersService } from '../../services/order/orders.service';
import { PersonalizeProductComponent } from '@app/modules/modals/personalize-product/personalize-product.component';

@Component({
    selector: 'best-sales',
    templateUrl: 'best-sales.component.html',
    styleUrls: ['best-sales.component.scss']
})

export class BestSalesComponent {
    bestSalesProduct: any[] = [];
    loadBestSales: boolean;
    close = false;
    idPdv: string;
    bsModalRef: BsModalRef;
    chosenOrderType: number;
    orderType: number;
    subscriptions2: Subscription[] = [];
    orderProg;
    constructor(
        private pdvService: PdvService,
        private productService: ProductService,
        private ordersService: OrdersService,
        private modalService: BsModalService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private route: ActivatedRoute,
        private router: Router,
    ) {
    }

    ngOnInit() {
        this.idPdv = this.pdvService.idPdv;
        const subs5 = this.ordersService.orderProg.subscribe((orderProg) => {
            this.orderProg = orderProg;
        });
        const subs9 = this.ordersService.orderType.subscribe((orderType) => {
            this.orderType = orderType;
        });
        const subs2 = this.ordersService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
            if (this.chosenOrderType > 0) {
                this.orderType = chosenOrderType;
            }
            this.getBestSales();
        });
        this.subscriptions2.push(subs2, subs5, subs9);
    }

    PersonalizeModal(i) {
        if (this.chosenOrderType > 0) {
            let product = this.bestSalesProduct[i];
            this.bsModalRef = this.modalService.show(PersonalizeProductComponent, { class: 'modal-content3' });
            this.bsModalRef.content.product = product;
        } else {
            this.setOrderType();
        }
    }

    setOrderType() {
        this.route.params.subscribe(params => {
            if (params['menu']) {
                this.router.navigate(["/modes"], { queryParams: { menu: params['menu'] } });
            }
            if (params['family']) {
                let querparams = { famille: params['family'] }
                this.router.navigate(["/modes"], { queryParams: querparams });
            }
            if (!params['menu'] && !params['family']) {
                this.router.navigate(["/modes"]);
            }
        })
    }

    getBestSales() {
        this.loadBestSales = true;
        return this.productService.getBestSales(this.orderType, this.orderProg).toPromise().then(
            (products: any[]) => {
                this.bestSalesProduct = products;
                this.loadBestSales = false;
            }
        )
    }

    addElementToBasket(i) {
        if (this.chosenOrderType > 0) {
            let product = this.bestSalesProduct[i];
            let element = {
                id: product.id,
                code: product.code,
                name: product.name,
                family: product.family,
                size: product.sizes[product.size],
                comment: '',
                qty: 1,
                removedCompositions: [],
                supplements: [],
                optionIngredients: [],
                total: 0,
                vat: product.vat,
                priceSuppApp: product.priceSuppApp,
                priceWithSupp: Number(product.sizes[product.size].price),
                maxNbrIngOptions: product.maxNbrIngOptions,
                hasSupp: product.hasSupp
            }
            element.total += Number(element.size.price);
            element.total *= Number(element.qty);
            this.ordersService.addElementToOrder(element);
        } else {
            this.setOrderType();
        }
    }
    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }
    ngOnDestroy() {
        this.unsubscribe2();
    }

    goToTopCart() {
        if (isPlatformBrowser(this.platformId)) {
            let element = document.getElementById('carte');
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }
}
